
import { Box } from '@material-ui/core'

import NewStartYourSearch from 'components/NewStartYourSearch'

interface IStartYourSearch {
  onCloseFocusDropdown: () => void
}

const StartYourSearch = ({ onCloseFocusDropdown }: IStartYourSearch) => {
  return (
    <Box mx={2}>
      <NewStartYourSearch
        condensed
        pathname={window.location.pathname}
        onSelect={onCloseFocusDropdown}
      />
    </Box>
  )
}

export default StartYourSearch
